@if (!useH5Title) {
  <h4>{{ 'common.document.title' | translate }}</h4>
} @else {
  <h5>{{ 'common.document.title' | translate }}</h5>
}

<div class="btn-bar">
  <button class="btn btn-primary" type="button"
    (click)="openAddDocumentToEquipmentModal()"
    translate="common.document.action.addDocument">
  </button>
</div>

@if (documents.length > 0) {
  <div class="table-responsive">
    <table class="table table-striped" [attr.aria-label]="'common.document.viewTitle' | translate">
      <thead>
        <tr>
          <th scope="col" translate="common.document.table.title"></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        @for (doc of documents; track doc) {
          <tr>
            <td class="align-middle">{{ doc.title }}</td>
            <td class="text-end">
              <button class="btn btn-link btn-sm" type="button"
                (click)="downloadItem(doc)"
                title="{{'common.tooltip.download' | translate}}">
                <fa-icon [icon]="faDownload"></fa-icon>
              </button>
              <button class="btn btn-link btn-sm" type="button"
                (click)="deleteItem(doc)"
                title="{{'common.tooltip.delete' | translate}}">
                <fa-icon [icon]="faTrash"></fa-icon>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

